import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
function isMsalReady(status) {
    return status === InteractionStatus.None;
}
export function RequireAuth() {
    const { inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();
    if (!isMsalReady(inProgress)) {
        return (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-background text-sm text-muted-foreground", children: "Securing session\u2026" }));
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/login", state: { from: location }, replace: true });
    }
    return _jsx(Outlet, {});
}
